<template>
  <jd-dialog
    align-center
    :visible.sync="visible"
    :show-close="true"
    :title="isBatch ? '批量审核' : '审核'"
    width="750px"
    @close="close"
    class="process-dailog"
  >
    <div class="process-dialog-content">
      <template v-if="isBatch">
        <jd-tip class="tip-bottom">
          <div>
            <p>
              剩余可通过审核人数：{{ canProcessNum }} 当前已选择用户数：{{
                proccessSelection.length
              }}
            </p>
          </div>
        </jd-tip>
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="batch-proccess-form"
        >
          <el-form-item label="审核结果：" prop="processStatus" required>
            <el-radio-group v-model="formData.processStatus">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核备注：">
            <el-input
              type="textarea"
              class="text-arear-height"
              v-model="formData.processRemark"
              placeholder="输入审核结果备注"
              :maxlength="100"
              show-word-limit
            ></el-input>
            <div>已设置审核通过结果可见，审核的备注将会展示给用户</div>
          </el-form-item>
        </el-form>
      </template>
      <template v-else>
        <jd-tip class="tip-bottom">
          <div>
            <p>剩余可通过审核人数：{{ canProcessNum }}</p>
          </div>
        </jd-tip>
        <div class="row-detail">
          <div class="row-item" v-if="rowData.chaosPin">
            <div class="row-item-label">用户pin:</div>
            <div class="row-item-value">{{ rowData.chaosPin }}</div>
          </div>
          <div class="row-item" v-if="rowData.memberNick">
            <div class="row-item-label">用户昵称:</div>
            <div class="row-item-value">{{ rowData.memberNick }}</div>
          </div>
          <div class="row-item" v-if="rowData.createTime">
            <div class="row-item-label">提交时间:</div>
            <div class="row-item-value">{{ rowData.createTime }}</div>
          </div>
        </div>
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="process-form"
        >
          <el-form-item label="审核结果：" prop="processStatus" required>
            <el-radio-group
              v-model="formData.processStatus"
              :disabled="rowData.processStatus == '已通过'"
            >
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核备注：">
            <el-input
              class="text-arear-height"
              type="textarea"
              v-model="formData.processRemark"
              placeholder="输入审核结果备注"
              :maxlength="100"
              show-word-limit
              :disabled="rowData.processStatus == 1"
            ></el-input>
            <div>已设置审核通过结果可见，审核的备注将会展示给用户</div>
          </el-form-item>
        </el-form>
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <jd-button
        type="blue"
        @click="submit('ruleForm')"
        :loading="loading"
        :disabled="rowData.processStatus == 1"
        >确定</jd-button
      >
      <jd-button @click="close">取消</jd-button>
    </span>
  </jd-dialog>
</template>

<script>
import { getCanProcessNum } from "@/api/jhk/politely";
import { processXhsShowProduct, processCalendarCheckIn } from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import {
  processQuestionnaireRecord,
  getQtCanProcessNum
} from "@/api/jhk/questionnaire.js";
/**晒单有礼-批量审核,单个审核*/
export default {
  name: "ProcessInfo",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * 操作类型 batch 批量 single 单个
     */
    isBatch: {
      type: Boolean,
      default: false,
    },
    /**当前点击数据详情 */
    rowData: {
      type: Object,
      default: () => ({}),
    },

    activityId: {
      type: String,
      default: "",
    },

    /**批量审核选择的列表 */
    proccessSelection: {
      type: Array,
      default: () => [],
    },
    actType: {
      type: Number,
      default: 80,
    },
    /**审核备注展示 */
    // isShowAuditResult: {
    //   type:Boolean,
    //   default: true
    // }
  },
  data() {
    return {
      loading: false,
      visible: false,
      formData: {
        processRemark: "",
        processStatus: 1,
      },
      rules: {
        processStatus: [
          { required: true, message: "请选择审核结果", trigger: "change" },
        ],
      },

      canProcessNum: null, //剩余可通过审批人数
    };
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
        this._getCanProcessNum();
        this.$nextTick(() => {
          this.$refs["ruleForm"].clearValidate();
        });
        this.formData.processStatus = 1;
        this.formData.processRemark = "";
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    async _getCanProcessNum() {
      let reqFn
      if(this.actType == 47) {
        reqFn = getQtCanProcessNum
      } else {
        reqFn = getCanProcessNum
      }
      const res = await reqFn({
        activityId: this.activityId,
      });
      if (res.code == 1) {
        this.canProcessNum = res.data == null ? "无限" : res.data;
      }
    },
    submit(formName) {
      const reqFn = {
        80: processXhsShowProduct,
        84: processCalendarCheckIn,
        47: processQuestionnaireRecord
      };
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.isBatch && this.formData.processStatus == 1) {
            if (
              this.canProcessNum != "无限" &&
              this.proccessSelection.length > this.canProcessNum
            ) {
              return this.$message.warning(
                "当前选择用户数已超过剩余可通过用户数，请关闭弹窗重试"
              );
            }
          }
          let params = {
            activityId: this.activityId,
            ...this.formData,
          };
          params.ids = this.isBatch
            ? this.proccessSelection.map((item) => item.id)
            : [this.rowData.id];
          this.loading = true;
          try {
            const res = await reqFn[this.actType](params);
            this.loading = false;
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.$emit("update");
              this.close();
            } else {
              this.$message.warning(res.message);
            }
          } catch (error) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.process-dialog-content {
  .row-detail {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;

    .row-item {
      display: flex;
      align-items: center;
      width: calc(33.33% - 20px / 3);
      padding: 10px 0px;
      margin-left: 10px;
      margin-bottom: 10px;

      &:nth-child(3n + 1) {
        margin-left: 0px;
      }

      .row-item-label {
        min-width: 86px;
        text-align: right;
      }

      .row-item-value {
        display: flex;
        align-items: center;
        margin-left: 10px;
      }
    }
  }

  .process-form {
    padding-top: 10px;
    border-top: 1px dashed #3333;
  }

  .batch-proccess-form {
    margin-top: 10px;
  }
}
/deep/ .el-dialog {
  max-height: 780px;
  overflow-y: auto;
}
/deep/.el-textarea.is-disabled .el-textarea__inner {
  height: 120px !important;
  min-height: 120px !important;
}
/deep/.el-textarea__inner {
  height: 120px !important;
  min-height: 120px !important;
}
</style>
